/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import ElectrorentLogoSVG from 'components/ElectrorentLogo/ElectrorentLogoSVG';
import MicroleaseLogoSVG from 'components/ElectrorentLogo/MicroleaseLogoSVG';
import NextIcon from 'resources/img/NextIcon';

import styles from './AppReleaseInfo.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

type TypeProps = {|
  isHovered?: boolean,
|};

function AppReleaseInfo(props: TypeProps): React.Element<*> {
  const { isHovered }: TypeProps = props;

  const isHoveredClass: string = isHovered ? styles['is-hovered'] : '';
  const isExpandedClass: string = isHovered ? styles['expanded'] : '';

  return (
    <div className={`${styles['app-release-info']} ${isHoveredClass}`}>
      <div className={styles['logo-container']}>
        {process.env.REACT_APP_PORTAL_NAME.toLowerCase() === 'myer' ? (
          <ElectrorentLogoSVG variant="portal" className={styles['logo']} />
        ) : (
          <MicroleaseLogoSVG variant="portal" className={styles['logo']} />
        )}
        <p>{process.env.REACT_APP_VERSION_NUMBER}</p>
      </div>
      <div
        className={`${styles['trigger-container']} ${isExpandedClass}`}
        onClick={e => props.toggleNavigation(e)}
      >
        <NextIcon />
      </div>
    </div>
  );
}

export default AppReleaseInfo;
